var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"secondary","flat":""}},[_c('v-toolbar-title',[_vm._v("Merge Products")]),_c('v-spacer')],1),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}})],1)],1),_c('snackbar',{ref:"snackbar"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }